import { gql } from '@apollo/client';

/**
 * Set an account's spending caps. Passing null for a cap clears it, which is
 * what "no limit" means here — the backend stops refusing that account's calls.
 */
export const SET_LLM_USER_BUDGET = gql`
  mutation SetLlmUserBudget(
    $userId: String!
    $monthlyCapUsd: Float
    $dailyCapUsd: Float
    $note: String
  ) {
    setLlmUserBudget(
      userId: $userId
      monthlyCapUsd: $monthlyCapUsd
      dailyCapUsd: $dailyCapUsd
      note: $note
    ) {
      userId
      monthlyCapUsd
      dailyCapUsd
      spentMonthToDateUsd
      spentLast24hUsd
      note
      updatedBy
    }
  }
`;

/**
 * Set a model's rates. Takes a LIST, so several models can be re-priced in one
 * call, and answers with a result per model rather than one verdict.
 */
export const UPSERT_LLM_PRICING = gql`
  mutation UpsertLlmPricing($objIn: [LlmPricingUpsertInput!]!) {
    upsertLlmPricing(objIn: $objIn) { success modelId message }
  }
`;

/** Drop rates for models. `modelIds` is a list, like the upsert. */
export const DELETE_LLM_PRICING = gql`
  mutation DeleteLlmPricing($objIn: LlmPricingDeleteInput!) {
    deleteLlmPricing(objIn: $objIn) { success modelId message }
  }
`;
